import * as fabric from 'office-ui-fabric-react';
import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as pages from '../index';

enum WizardDisplay {
    OrganizationInformation,
    Devices,
    Locations,
    Queues
}

const WizardPage: FC = () => {
    const [percent, setPercent] = useState<number>(0.01);
    const [wizardPageDisplay, setWizardPageDisplay] = useState<WizardDisplay>(WizardDisplay.OrganizationInformation);
    const navigate = useNavigate();

    const onButtonClickNext = () => {
        switch (wizardPageDisplay) {
            case WizardDisplay.OrganizationInformation:
                setWizardPageDisplay(WizardDisplay.Devices);
                setPercent(percent + 0.37);
                break;
            case WizardDisplay.Devices:
                setWizardPageDisplay(WizardDisplay.Locations);
                setPercent(0.72);
                break;
            case WizardDisplay.Locations:
                setWizardPageDisplay(WizardDisplay.Queues);
                setPercent(1);
                break;
            case WizardDisplay.Queues:
            default:
                break;
        }
    };

    const onButtonClickPrevious = () => {
        switch (wizardPageDisplay) {
            case WizardDisplay.Queues:
                setWizardPageDisplay(WizardDisplay.Locations);
                setPercent(0.72);
                break;
            case WizardDisplay.Locations:
                setWizardPageDisplay(WizardDisplay.Devices);
                setPercent(0.37);
                break;
            case WizardDisplay.Devices:
                setWizardPageDisplay(WizardDisplay.OrganizationInformation);
                setPercent(0.01);
                break;
            case WizardDisplay.OrganizationInformation:
            default:
                break;
        }
    };

    return (
        <div className="ms-Grid">
            <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm3 ms-md3 ms-lg3">
                    <fabric.Text
                        variant="xLarge"
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                            setWizardPageDisplay(WizardDisplay.OrganizationInformation);
                            setPercent(0.01);
                        }}
                    >
                        Organizacijos informacija
                    </fabric.Text>
                </div>

                <div style={{ textAlign: 'center' }} className="ms-Grid-col ms-sm3 ms-md3 ms-lg3">
                    <fabric.Text
                        variant="xLarge"
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                            setWizardPageDisplay(WizardDisplay.Devices);
                            setPercent(0.37);
                        }}
                    >
                        Įrenginiai
                    </fabric.Text>
                </div>
                <div style={{ textAlign: 'right' }} className="ms-Grid-col ms-sm3 ms-md3 ms-lg3">
                    <fabric.Text
                        variant="xLarge"
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                            setWizardPageDisplay(WizardDisplay.Locations);
                            setPercent(0.72);
                        }}
                    >
                        Lokacijos
                    </fabric.Text>
                </div>
                <div style={{ textAlign: 'right' }} className="ms-Grid-col ms-sm3 ms-md3 ms-lg3">
                    <fabric.Text
                        variant="xLarge"
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                            setWizardPageDisplay(WizardDisplay.Queues);
                            setPercent(1);
                        }}
                    >
                        Eilės
                    </fabric.Text>
                </div>
            </div>
            <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                    <fabric.ProgressIndicator theme={fabric.getTheme()} percentComplete={percent} barHeight={8} />
                </div>
            </div>

            <div style={{ paddingTop: '20px' }}>
                <div style={{ textAlign: 'center', display: wizardPageDisplay === WizardDisplay.OrganizationInformation ? 'initial' : 'none' }}>
                    <pages.OrganizationPage />
                </div>
                <div style={{ display: wizardPageDisplay === WizardDisplay.Devices ? 'initial' : 'none' }}>
                    <pages.DevicesPage />
                </div>
                <div style={{ display: wizardPageDisplay === WizardDisplay.Locations ? 'initial' : 'none' }}>
                    <pages.LocationsPage />
                </div>
                <div style={{ display: wizardPageDisplay === WizardDisplay.Queues ? 'initial' : 'none' }}>
                    <fabric.Stack tokens={{ padding: 30 }}>
                        <fabric.Stack.Item align="center">
                            <fabric.Text variant="xLarge">Eilių valdymo langas</fabric.Text>
                        </fabric.Stack.Item>
                    </fabric.Stack>
                    <pages.QueuesPage />
                </div>
                <fabric.Stack>
                    <fabric.Stack.Item align="end">
                        {wizardPageDisplay !== WizardDisplay.OrganizationInformation && (
                            <fabric.PrimaryButton style={{ margin: '15px' }} onClick={() => onButtonClickPrevious()}>
                                Atgal
                            </fabric.PrimaryButton>
                        )}
                        {wizardPageDisplay !== WizardDisplay.Queues ? (
                            <fabric.PrimaryButton style={{ margin: '15px' }} onClick={() => onButtonClickNext()}>
                                Kitas
                            </fabric.PrimaryButton>
                        ) : (
                            <fabric.PrimaryButton style={{ margin: '15px' }} onClick={() => navigate('/administration')}>
                                Baigti
                            </fabric.PrimaryButton>
                        )}
                    </fabric.Stack.Item>
                </fabric.Stack>
            </div>
        </div>
    );
};

export default WizardPage;
